
import { Dispatcher, throwTraceError } from '@fanfanlo';
import { ITriggerOrActionListPageParsedResult, ITriggerOrActionListParamsData } from '../common';
import { ProjectMemberType } from '../core'
import _ from 'lodash';
import { IActionData } from '../action';
import { ITriggerData } from '../trigger';

const dispatcher = new Dispatcher()
enum EditType {
    add = "add",
    updateJavaData = "updateJavaData",
    updateShellData = "updateShellData",
}
export interface IProjectEditEvent<T> {
    editType?: EditType
    // editing target type
    projectMemberType: ProjectMemberType
    // IAction or ITrigger's type, also it's namespace
    classType?: string
    info?: ITriggerOrActionListPageParsedResult
    data: T
    projectInfo?: ITriggerOrActionListParamsData
}

function dispatchEditEvent<T>(editType: EditType, event: IProjectEditEvent<T>) {
    // console.log('dispatchEditEvent', editType, event)
    dispatcher.dispatch(editType, event)
}

function onEditJavaData<T>(event: IProjectEditEvent<T>) {
    // console.log('on edit java data', event)
    switch (event.projectMemberType) {
        case ProjectMemberType.action:
            onActionEdit(EditType.updateJavaData, event);
            break;
        case ProjectMemberType.trigger:
            onTriggerEdit(EditType.updateJavaData, event);
            break;
        default: {
            const msg = `on edit java data unknow event type ${event.projectMemberType}`
            throwTraceError(msg, event)
        }
    }
}

function onTriggerEdit<T>(editType: EditType, event: IProjectEditEvent<T>) {
    // console.log('on trigger edit', event)
    const trigger = event.projectInfo?.trigger;
    if (!trigger) {
        const msg = `no trigger when edit trigger java data`
        return throwTraceError(msg, event)
    }
    switch (editType) {
        case EditType.updateJavaData:
            // console.log('before merge', trigger.javaData)
            _.merge(trigger.javaData, event.data);
            // console.log('after merge', trigger.javaData)
            break;
        case EditType.updateShellData:
            _.merge(trigger.shellData, event.data)
            break;
        default: {
            const msg = `on trigger edit unknow event type ${event.editType}`
            throwTraceError(msg, event)
        }
    }
}
function onActionEdit<T>(editType: EditType, event: IProjectEditEvent<T>) {
    console.log('on action edit', event)
    const action = event.projectInfo?.action;
    if (!action) {
        const msg = `no action when edit action java data`
        return throwTraceError(msg, event)
    }
    switch (editType) {
        case EditType.updateJavaData:
            console.log('before merge', JSON.parse(JSON.stringify(action.javaData)))
            _.merge(action.javaData, event.data);
            console.log('after merge', JSON.parse(JSON.stringify(action.javaData)))
            break;
        case EditType.updateShellData:
            _.merge(action.shellData, event.data)
            break;
        default: {
            const msg = `on action edit unknow event type ${event.editType}`
            throwTraceError(msg, event)
        }
    }
}
function onAdd<T>(event: IProjectEditEvent<T>) {
    switch (event.projectMemberType) {
        case ProjectMemberType.actionGroup:
            onActionGroupAdd(event);
            break;
        case ProjectMemberType.triggerGroup:
            onTriggerGroupAdd(event);
            break;

    }
}
function onTriggerGroupAdd<T>(event: IProjectEditEvent<T>) {
    const group = event.projectInfo?.triggerGroup
    if (!group) {
        const msg = `no trigger group when edit action group add`
        return throwTraceError(msg, event)
    }
    group.list.push(event.data as ITriggerData<any, any>)
}
function onActionGroupAdd<T>(event: IProjectEditEvent<T>) {
    const group = event.projectInfo?.actionGroup
    if (!group) {
        const msg = `no action group when edit action group add`
        return throwTraceError(msg, event)
    }
    group.list.push(event.data as IActionData<any, any>)
}
function init() {
    dispatcher.addListener(EditType.updateJavaData, onEditJavaData)
    dispatcher.addListener(EditType.add, onAdd)
}
export const projectEventUtils = {
    init,
    dispatcher,
    dispatchEditEvent,
    EditType,
}
